import { dataChatSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChatSolid = /*#__PURE__*/createIcon(dataChatSolid)
export default IconChatSolid
